var map = {
	"./en-US": "c909",
	"./en-US.js": "c909",
	"./zh-CN": "85cf",
	"./zh-CN.js": "85cf",
	"./zh-TW": "48f3",
	"./zh-TW.js": "48f3"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9e08";
module.exports = webpackAsyncContext;